import { CloudKeyIcon } from './CloudKeyIcon';

/**
 * author: frankgrinaert
 * id 3694A84E-0A8D-420F-98C3-C892312B29D4
 * name cloud-key
 * version: 7.3.67
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cloud-key.svg
 * tags
 * - Cloud 
 */
export const CloudAccessIcon = CloudKeyIcon;
export default CloudAccessIcon